import { useEffect, useRef, useState } from 'react';
import moment from 'moment/moment';

interface IProps {
  time: any;
}

const Timer = (props: IProps) => {
  const [current, setCurrent] = useState(null);
  const [duration, setDuration] = useState(0);
  const timeout = useRef(null);

  useEffect(() => {
    if (current !== props.time && props.time !== null) {
      setCurrent(props.time);
    }
  }, [props.time]);

  useEffect(() => {
    update();
  }, [current]);

  const update = () => {
    let now = moment();
    let then = moment(current);
    let duration = moment.duration(then.diff(now, 'milliseconds'));
    setDuration(duration.asSeconds());
    if (timeout.current) clearTimeout(timeout.current);
    timeout.current = setTimeout(update, 1000);
  };

  let min = Math.floor(duration / 60);
  let seconds = Math.floor(duration % 60);

  return <div>{duration >= 0 ? min + ':' + (seconds < 10 ? '0' + seconds : seconds) : null}</div>;
};

export default Timer;
